import React from 'react'


export default function Products(){
    return <h1 className="products">Products</h1>
}